class DateInput extends HTMLElement {
  constructor() {
    super();
    this.input = document.createElement('input');
    this.input.type = 'text';
    this.input.classList.add('input');
    this.input.maxLength = 10;
    this.input.autocomplete = 'off';
    this.startdatumOutput = document.querySelector('#startdatum');
    this.errorMessage = document.createElement('span');
    this.errorMessage.classList.add('form-error-message');
    this.errorMessage.setAttribute('role', 'alert');
    this.errorMessage.setAttribute('aria-live', 'polite');
  }

  _setValidity(message) {
    this.input.setCustomValidity(message);
    this.errorMessage.setAttribute('aria-hidden', message ? 'false' : 'true');

    if (message) {
      clearTimeout(this._errorClearTimer);
      this.errorMessage.textContent = message;
      this.classList.add('has-error');
      return;
    }

    this.classList.remove('has-error');
    clearTimeout(this._errorClearTimer);
    this._errorClearTimer = setTimeout(() => {
      if (!this.classList.contains('has-error')) {
        this.errorMessage.textContent = '';
      }
    }, 300);
  }

  connectedCallback() {
    if (this.hasAttribute('name')) this.input.name = this.getAttribute('name');
    if (this.hasAttribute('required')) this.input.required = true;
    if (this.hasAttribute('placeholder')) this.input.placeholder = this.getAttribute('placeholder');

    this.appendChild(this.input);
    this.appendChild(this.errorMessage);

    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Backspace') {
        const pos = this.input.selectionStart;
        const val = this.input.value;

        if (pos > 0 && val[pos - 1] === '.' && /\d/.test(val[pos - 2])) {
          e.preventDefault();
          const newValue = val.slice(0, pos - 2) + val.slice(pos);
          this.input.value = this._formatInput(newValue);
          const newPos = pos - 2;
          this.input.setSelectionRange(newPos, newPos);
        }
      }
    });

    this.input.addEventListener('input', () => {
      const raw = this.input.value.replace(/\D/g, '').slice(0, 8);
      this.input.value = this._formatInput(raw);
      this._setValidity('');
      this.startdatumOutput.textContent = this.input.value;
    });

    this.input.addEventListener('blur', () => {
      const raw = this.input.value.replace(/\D/g, '').slice(0, 8);
      if (raw.length < 8) {
        this._setValidity(this.dataset.errorIncomplete || 'Incomplete date');
        return;
      }

      const dd = raw.slice(0, 2);
      const mm = raw.slice(2, 4);
      const yyyy = raw.slice(4, 8);

      const day = parseInt(dd, 10);
      const month = parseInt(mm, 10);
      const year = parseInt(yyyy, 10);
      const maxDay = new Date(year, month, 0).getDate();

      const isValid =
        month >= 1 && month <= 12 &&
        day >= 1 && day <= maxDay;

      if (isValid) {
        const formatted = [
          day.toString().padStart(2, '0'),
          month.toString().padStart(2, '0'),
          year
        ].join('.');
        this.input.value = formatted;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const entered = new Date(year, month - 1, day);

        if (entered < today) {
          this._setValidity(this.dataset.errorPast || 'Date cannot be in the past');
        } else {
          this._setValidity('');
        }
      } else {
        this._setValidity(this.dataset.errorInvalid || 'Invalid date');
      }
    });
  }

  _formatInput(raw) {
    raw = raw.replace(/\D/g, '').slice(0, 8);
    let formatted = '';
    if (raw.length >= 1) formatted += raw.slice(0, 2);
    if (raw.length >= 2) formatted += '.';
    if (raw.length >= 3) formatted += raw.slice(2, 4);
    if (raw.length >= 4) formatted += '.';
    if (raw.length >= 5) formatted += raw.slice(4, 8);
    return formatted;
  }
}

customElements.define('date-input', DateInput);
